import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PeFormQuestionHeadingApiModel } from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class PeFormQuestionHeadingsService {
  public url = 'pe-form-question-headings';

  constructor(private readonly http: HttpClientService) {}

  public add(model): Observable<PeFormQuestionHeadingApiModel> {
    return this.http.post<PeFormQuestionHeadingApiModel>(`${this.url}/add`, model);
  }

  public update(model): Observable<PeFormQuestionHeadingApiModel> {
    return this.http.put<PeFormQuestionHeadingApiModel>(`${this.url}/update`, model);
  }

  public delete(id: number): Observable<Object> {
    return this.http.delete(`${this.url}/delete/${id}`);
  }
}
